
//models 
import { Account } from '../models/Entities/CashFlow/Account/Account';
import { NewAccount } from '../models/Entities/CashFlow/Account/NewAccount';
import { DebtIndicators } from '../models/Entities/CashFlow/Debt/DebtIndicators';
import { IResult } from '../models/HttpResult';

//Functions
import * as Functions from '../functions/common';

// urls
const BaseURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'cashflow/accounts/';
const DebtIndicatorsURL = process.env.REACT_APP_BILLER_API_GATEWAY + 'cashflow/debts/indicators/';

// Get all accounts by owner
export const GetAccountsByOwnerId = async (token: string, ownerIdentifier: string): Promise<Account[]> => {

    let RequestURL: string = BaseURL;

    try {
        const Response: Account[] = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
        .then((response) => {
            if (!response.ok) {
                throw response;
            } else {
                return response.json() as Promise<IResult<Account[]>>;
            }
        })
        .then((data: IResult<Account[]>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
                throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// Get account by id
export const GetAccountById = async (token: string, AccountId: number): Promise<Account> => {

    let RequestURL: string = BaseURL + AccountId;

    try {
        const Response: Account = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
        .then((response) => {
            if (!response.ok) {
                throw response;
            } else {
                return response.json() as Promise<IResult<Account>>;
            }
        })
        .then((data: IResult<Account>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
                throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// Create account
export const CreateAccount = async (token: string, account: NewAccount): Promise<Account> => {

    let RequestURL: string = BaseURL;

    try {
        const Response: Account = await fetch(RequestURL, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            },
            body: JSON.stringify(account)
        })
        .then((response) => {
            if (!response.ok) {
                throw response;
            } else {
                return response.json() as Promise<IResult<Account>>;
            }
        })
        .then((data: IResult<Account>) => {
            return data.data;
        })
        .catch((error: any) =>
            error.text().then((body: any) => {
                throw Functions.HttpErrorHandler(body, error);
            })
        );

        return Response;
    } catch (error: any) {
        throw error;
    }
};

// Get debt indicators by user id
export const GetDebtIndicatorsByUserId = async (token: string, userId: string): Promise<DebtIndicators> => {

    const RequestURL: string = DebtIndicatorsURL + userId;

    try {
        const Response: DebtIndicators = await fetch(RequestURL, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        })
            .then((response) => {
                if (response.ok) {
                    return response.json() as Promise<IResult<DebtIndicators>>;
                }

                throw response;
            })
            .then((data: IResult<DebtIndicators>) => {
                return data.data;
            })
            .catch((error: any) =>
                error.text().then((body: any) => {
                    throw Functions.HttpErrorHandler(body, error);
                })
            );

        return {
            pendingToPay: Response?.pendingToPay || [],
            pendingToCollect: Response?.pendingToCollect || []
        };
    } catch (error: any) {
        throw error;
    }
};